import React from "react";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
`;

const LoaderContainer = styled.div`
  width: 200px;
  height: 200px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Circle = styled.div<{ delay: number }>`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.color || "#197850"};
  animation: ${fadeInOut} 1s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
`;

const Spinner = styled.div`
  width: 100px;
  height: 100px;
  border: 4px solid rgba(25, 120, 80, 0.1);
  border-top: 4px solid #197850;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export default function LoaderAnimation({ color = "#197850" }) {
  return (
    <LoaderContainer>
      <Spinner />
      {[...Array(8)].map((_, i) => (
        <Circle
          key={i}
          color={color}
          delay={i * 0.125}
          style={{
            transform: `rotate(${i * 45}deg) translateY(-40px)`,
          }}
        />
      ))}
    </LoaderContainer>
  );
}